import { render } from "./ToolsTbView.vue?vue&type=template&id=2153ab70&scoped=true"
import script from "./ToolsTbView.vue?vue&type=script&lang=js"
export * from "./ToolsTbView.vue?vue&type=script&lang=js"

import "./ToolsTbView.vue?vue&type=style&index=0&id=2153ab70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2153ab70"]])

export default __exports__